import { create } from "zustand"

interface AdminPageStore {
  selectedCoachProfileId: number | null
  setSelectedCoachProfileId: (id: number | null) => void

  searchValue: string
  setSearchValue: (value: string) => void

  debouncedSearchValue: string
  setDebouncedSearchValue: (value: string) => void
}

const useAdminPageStore = create<AdminPageStore>()((set) => ({
  selectedCoachProfileId: null,
  setSelectedCoachProfileId: (id: number | null) =>
    set({ selectedCoachProfileId: id }),

  searchValue: "",
  setSearchValue: (value: string) => set({ searchValue: value }),

  debouncedSearchValue: "",
  setDebouncedSearchValue: (value: string) =>
    set({ debouncedSearchValue: value }),
}))

export default useAdminPageStore
